import { render, staticRenderFns } from "./etusivu-erikoistuja.vue?vue&type=template&id=0d0ba72d&"
import script from "./etusivu-erikoistuja.vue?vue&type=script&lang=ts&"
export * from "./etusivu-erikoistuja.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports